import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataStoreKey } from '@compiere-ws/models/compiere-data-json';
import { RecentItem } from '@compiere-ws/models/compiere-recent-item';
import { AppConfig } from '@iupics-config/app.config.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CompiereRecentItemService {
  private url: string;

  constructor(
    private config: AppConfig,
    private http: HttpClient
  ) {
    this.url = this.config.getBackendResource('recentItem');
  }

  getRecentItems(): Observable<RecentItem[]> {
    return this.http.get<RecentItem[]>(this.url);
  }

  addRecentItem(item: RecentItem): Observable<boolean> {
    return this.http.post<boolean>(this.url, item);
  }

  deleteRecentItems(
    windowId: DataStoreKey['windowId'],
    tabId: DataStoreKey['tabId'],
    recordIds: number[]
  ): Observable<any> {
    return this.http.request('delete', `${this.url}?windowId=${windowId}&tabId=${tabId}`, {
      body: recordIds,
    });
  }
}
